import { useState } from "react";
import api from "@/lib/api";
import { PaperPlaneRight } from "@phosphor-icons/react";

export default function NewsletterForm({ dark = false }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ status: "idle", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    setState({ status: "loading", message: "" });
    try {
      const r = await api.post("/newsletter/subscribe", { email });
      setState({ status: "done", message: r.data.message });
      setEmail("");
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = Array.isArray(detail) ? "Please enter a valid email address." : (detail || "Subscription failed — try again.");
      setState({ status: "error", message: msg });
    }
  };

  return (
    <div>
      <form onSubmit={submit} className="flex">
        <input
          data-testid="newsletter-email-input"
          type="email"
          required
          placeholder="your@email.co.nz"
          value={email}
          onChange={e => setEmail(e.target.value)}
          className={`flex-1 min-w-0 px-3 py-2.5 text-sm border outline-none ${dark ? "bg-zinc-800 border-zinc-600 text-white placeholder:text-zinc-500 focus:border-white" : "bg-white border-zinc-900 focus:bg-yellow-50"}`}
        />
        <button
          data-testid="newsletter-submit-btn"
          disabled={state.status === "loading"}
          className="px-4 bg-[#ff3333] text-white border border-[#ff3333] hover:bg-[#cc0000] hover:border-[#cc0000] transition-colors disabled:opacity-50"
          aria-label="Subscribe"
        >
          <PaperPlaneRight size={16} weight="bold" />
        </button>
      </form>
      {state.message && (
        <div data-testid="newsletter-msg" className={`mt-2 text-xs uppercase tracking-widest font-bold font-[Outfit] ${state.status === "error" ? "text-[#ff3333]" : dark ? "text-emerald-400" : "text-emerald-700"}`}>
          {state.message}
        </div>
      )}
    </div>
  );
}
